import React, { useState, useEffect } from "react";

import axios from "axios";
import {
  addDictationAudit,
  updateDictationAssignment,
  getScribeUserList,
} from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";
import { LinearProgress, Modal, Select } from "@mui/material";

const SubmitDictation = (props) => {
  const { id } = props;
  const [comment, setComment] = useState("");
  const [scribes, setScribes] = useState([]);
  const [selScribe, setSelScribe] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const userData = useUserData();
  const id_token = userData?.access_token;

  const fetchScribes = async (token) => {
    const response = await getScribeUserList(token, id_token);
    if (response && response !== "ERROR") await setScribes(response);
    await setLoading(false);
  };

  useEffect(() => {
    const source = axios.CancelToken.source();
    fetchScribes(source.token);
    return () => {
      source.cancel();
    };
  }, []);

  const onSubmit = async () => {
    if (!comment || !selScribe) return;
    await setLoading(true);
    const commentPayload = {
      type: "Dictation",
      record_data: {
        dictation_id: id,
        scribe_id: userData.email,
        description: comment,
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    await addDictationAudit(commentPayload, id_token);
    const payload = {
      type: "Scribe",
      search_criteria: {
        scribe_id: selScribe,
        dictation_id: id,
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    const response = await updateDictationAssignment(payload, id_token);
    await setLoading(true);
    if (response === "ERROR") setError(true);
    else props.onClose();
  };

  return (
    <Modal onClose={props.onClose} open={true}>
      <div className="dictation-common-modal">
        <h3 className="dcm-title">Reassing Dictation</h3>
        {error && <p className="dcm-error">Failed to reassign</p>}
        {loading && <LinearProgress color="secondary" />}
        <div className="dcm-sel-scribe">
          <span>Select Scribe* </span>
          <Select
            native
            value={selScribe}
            onChange={(e) => setSelScribe(e.target.value)}
            autoWidth
          >
            <option aria-label="None" value="" />
            {scribes.map((s) => {
              if (s.scribe_id === userData.email) return null;
              return (
                <option value={s.scribe_id} key={s.id}>
                  {s.first_name} {s.last_name}
                </option>
              );
            })}
          </Select>
        </div>
        <textarea
          value={comment}
          className="dcm-textarea"
          onChange={(e) => setComment(e.target.value)}
          placeholder="Reason for reassignment*"
        />
        <button
          onClick={onSubmit}
          className={!comment || !selScribe ? "dcm-disable" : "dcm-save"}
          disabled={!comment || !selScribe ? 1 : 0}
        >
          Submit
        </button>
        <button onClick={props.onClose} className="dcm-cancel">
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default SubmitDictation;
